jQuery(document).ready(function ($) {

	new jBox('Tooltip', {
		attach: '.badge:not(.certificate-image .badge)',
		adjustPosition: true,
		zIndex: 9,
		addClass: 'tooltip-badge',
		position: {
			x: 'center',
			y: 'bottom'
		},
		getTitle: 'data-badge-title',
		getContent: 'data-badge-content',
	});

	new jBox('Tooltip', {
		attach: '.img-container:not(.certificate-image .img-container)',
		adjustPosition: true,
		zIndex: 9,
		addClass: 'tooltip-badge',
		position: {
			x: 'center',
			y: 'bottom'
		},
		getTitle: 'data-badge-title',
		getContent: 'data-badge-title',
	});

    $('#course-outline').on('click', function (e) {
        e.preventDefault();
        $('.course-outline').addClass('is-active');
        if ($('.course-outline').hasClass('is-active')) {
            $('.course-outline__top').show();
			if ($('.ways-to-learn').hasClass('is-active')) {
				$('.ways-to-learn').removeClass('is-active');
			}
        }
    });

    $('#close-sidebar').on('click', function (e) {
        e.preventDefault();
        $('.course-outline').removeClass('is-active');
        $('.course-outline__top').hide();
    });

    $('a#ways-to-learn-menu').on('click', function (e) {
        e.preventDefault();
        $('.ways-to-learn-menu').toggleClass('is-active');
        if ($('.ways-to-learn-menu').hasClass('is-active')) {
            $('.course-outline').removeClass('is-active');
            $('.course-outline__top').hide();
        }
    });

    $('#close-ways').on('click', function (e) {
        e.preventDefault();
        $('.ways-to-learn-menu').toggleClass('is-active');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.ways-to-learn-menu, #ways-to-learn-menu').length) {
            $('.ways-to-learn-menu').removeClass('is-active');
        }
    });

    $('#member-menu-toggle').hover(function () {
        $('#member-menu').addClass('is-active');
    });

	$('#member-menu').on('mouseleave', function (e) {

		// Ignore if any <a> element inside member-menu is focused
		if ($(this).find('a:focus').length > 0) {
			return;
		}

		$('#member-menu').removeClass('is-active');
	});

    $('#sidebar-category-select').on('change', function () {
        topicFilter = $(this).val();
        if (topicOrder === 'alphabetical') {
            $('#tsb-topics ol.recommended').addClass('alphabetical');
        } else {
            $('#tsb-topics ol.recommended').removeClass('alphabetical');
        }
        updateSidebarTopics();
    });

    $('#sidebar-order-select').on('change', function () {
        topicOrder = $(this).val();
        if (topicOrder === 'alphabetical') {
            $('#tsb-topics ol.recommended').addClass('alphabetical');
        } else {
            $('#tsb-topics ol.recommended').removeClass('alphabetical');
        }
        updateSidebarTopics();
    });

    let topicFilter = '';
    let topicOrder = getCookie("order_archive");
    if (topicOrder == '') {
        topicOrder = 'recommended';
    }

	function updateSidebarTopics() {
		let listContainer = $('#tsb-topics ol.recommended');
		var $fields, sorted;

		$fields = $("#tsb-topics ol.recommended li.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (topicOrder === 'recommended') {
				if (this.getAttribute("data-" + (topicFilter || 'default') + "-order")) {
					const newIndex = parseInt(this.getAttribute("data-" + (topicFilter || 'default') + "-order"), 10);
					if(!sorted[newIndex]) {
						sorted[newIndex] = [];
					}
					sorted[newIndex].push(this);
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-" + (topicOrder || 'alphabetical'))) {
					const newIndex = parseInt(this.getAttribute("data-" + (topicOrder || 'alphabetical')), 10);
					if(!sorted[newIndex]) {
						sorted[newIndex] = [];
					}
					sorted[newIndex].push(this);
				} else {
					unsorted.push(this);
				}
			}

		});
		let shownIndex = 1;
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			if(Array.isArray(element)){
				element.forEach(function (subElement) {
					listContainer.append(subElement);
					if (!$(subElement).find('a').text()) {
						return;
					}
					if (topicFilter) {
						if (!!$(subElement).attr('data-category') && $(subElement).attr('data-category').includes(topicFilter)) {
							$(subElement).show()
							let orderNum = '0' + shownIndex
							$(subElement).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
							shownIndex++;
						} else {
							$(subElement).hide();
						}
					} else {
						$(subElement).show()
						let orderNum = '0' + shownIndex
						$(subElement).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
						shownIndex++;
					}
				});
			}else {
				listContainer.append(element);
				if (!$(element).find('a').text()) {
					return;
				}
				if (topicFilter) {
					if (!!$(element).attr('data-category') && $(element).attr('data-category').includes(topicFilter)) {
						$(element).show()
						let orderNum = '0' + shownIndex
						$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
						shownIndex++;
					} else {
						$(element).hide();
					}
				} else {
					$(element).show()
					let orderNum = '0' + shownIndex
					$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
					shownIndex++;
				}
			}
		});
	}

    function initSortingAndFiltering() {
        topicFilter = getCookie("topic");
        topicOrder = getCookie("order_archive");

        $('#sidebar-category-select').val(topicFilter);
        $('#sidebar-order-select').val(topicOrder);
        if (topicOrder == '') {
            topicOrder = 'recommended';
        }

        if (topicOrder === 'alphabetical') {
            $('#tsb-topics ol.recommended').addClass('alphabetical');
        } else {
            $('#tsb-topics ol.recommended').removeClass('alphabetical');
        }

        updateSidebarTopics();
    }

    initSortingAndFiltering();

	let mainTopicFilter = '';
	let mainTopicOrder = '';

	$('#all-topic-order-select').on('change', function () {
		mainTopicOrder = $(this).val();
		if (mainTopicOrder === 'alphabetical') {
			$('#main-outline-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#main-outline-topics ol.recommended').removeClass('alphabetical');
		}
		updateMainTopicOutline();
	});
	$('#all-topic-category-select').on('change', function () {
		mainTopicFilter = $(this).val();
		updateMainTopicOutline();
	});

	function updateMainTopicOutline() {
		let listContainer = $('#main-outline-topics ol.recommended');
		var $fields, sorted;

		$fields = $("#main-outline-topics ol.recommended li.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (mainTopicOrder === 'recommended') {
				if (this.getAttribute("data-" + (mainTopicFilter || 'default') + "-order")) {
					sorted[parseInt(this.getAttribute("data-" + (mainTopicFilter || 'default') + "-order"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-alphabetical")) {
					sorted[parseInt(this.getAttribute("data-alphabetical"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			}

		});
		let shownIndex = 1;
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			listContainer.append(element);
			if (!$(element).find('a').text()) {
				return;
			}
			if (mainTopicFilter) {
				if (!!$(element).attr('data-category') && $(element).attr('data-category').includes(mainTopicFilter)) {
					$(element).show()
					let orderNum = '0' + shownIndex
					$(element).find('.list-order-number').text(orderNum.substr(orderNum.length - 2) + '.')
					shownIndex++;
				} else {
					$(element).hide();
				}
			} else {
				$(element).show()
				let orderNum = '0' + shownIndex
				$(element).find('.list-order-number').text(orderNum.substr(orderNum.length - 2) + '.')
				shownIndex++;
			}
		});
	}

	$('.wistia-play-button').on('click', function (e) {
		e.preventDefault();
		let videoId = $(this).attr('data-video-id');
		if (!videoId) {
			return;
		}
		window._wq = window._wq || [];
		_wq.push({
			id: videoId, onReady: function (video) {
				video.play();
			}
		});

	});

	checkAndSetDefaultCookie();


	mainTopicOrder = getCookie("order_archive");
	if (mainTopicOrder) {
		$('#all-topic-order-select').val(mainTopicOrder);
		$('#all-topic-order-select').trigger('change');
	}

	// Comparison Table
	$('.comparison-table__header').on('click', function () {
		$('.comparison-table__column').removeClass('comparison-table__column--active');
		$(this).parent().addClass('comparison-table__column--active');
	});

		// 948 in all.js
	$('#mobile-menu-toggle').on('click', function () {
		// if($('#site-search').hasClass('active')) {
		//   $('#site-search').show().attr('style', '').removeClass('active');
		//   $('#branding').css('padding-top', '20px');
		//   $('#mobile-search-toggle').css('margin-top', '0px');
		// }

		if (!$(this).hasClass('is-active')) {
			$('.attic').addClass('attic--mobile-open');
		}


		//$('#mobile-menu').toggle();
		$(this).toggleClass('is-active');

		$('#mobile-menu').toggleClass('mobile-menu--open');

	});

	$('#member-menu-toggle').on('keydown', function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			$(this).trigger('mouseenter');
		}
	});


	$('#mobile-menu').on('transitionend webkitTransitionEnd oTransitionEnd', function () {

		if (!$('#mobile-menu').hasClass('mobile-menu--open')) {
			$('.attic').removeClass('attic--mobile-open');
		}

	});

	$('#mobile-search-toggle').on('click', function () {
		$(this).toggleClass('is-active');
		$('#mobile-site-search').toggleClass('mobile-search--open');
	});

	$('select.selectric').selectric();

	$('.footer__mobile').on('change', 'select.selectric', function () {
		if ($(this).val()) {
			window.location.href = $(this).val();
		}
	});


});


function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


function checkAndSetDefaultCookie() {
	let order = getCookie("order_archive");
	if (order == "") {
		setCookie('order_archive', 'recommended', 10);
	}
}

document.addEventListener("DOMContentLoaded", function () {
    const menuLinks = document.querySelectorAll("#tsb-topics a.special-type");

    // Add tabindex to make links focusable
    menuLinks.forEach(link => {
        link.setAttribute("tabindex", "0");
    });

    // Handle keyboard navigation
    document.addEventListener("keydown", function (event) {
        const focusedElement = document.activeElement;

		if (event.key === "Tab") {
			if (!document.body.classList.contains("focuson")) {
				document.body.classList.add("focuson");
			}
		}

		const topicSidebar = document.querySelector("#topic-sidebar");
		if (topicSidebar && topicSidebar.classList.contains("is-active")) {
			const linksArray = Array.from(menuLinks).sort((a, b) => {
				const aVal = parseInt(a.parentElement.getAttribute('data-alphabetical'), 10) || 0;
				const bVal = parseInt(b.parentElement.getAttribute('data-alphabetical'), 10) || 0;
				return aVal - bVal;
			});
			const currentIndex = linksArray.indexOf(focusedElement);

            if (event.key === "ArrowDown") {
                // Move to the next menu item
                event.preventDefault();
                const nextIndex = (currentIndex + 1) % linksArray.length;
                linksArray[nextIndex].focus();
            } else if (event.key === "ArrowUp") {
                // Move to the previous menu item
                event.preventDefault();
                const prevIndex = (currentIndex - 1 + linksArray.length) % linksArray.length;
                linksArray[prevIndex].focus();
            }

			// Handle Esc key to close the topic sidebar
			const topicSidebarEl = document.querySelector("#topic-sidebar");
			if (event.key === "Escape" && topicSidebarEl && topicSidebarEl.classList.contains("is-active")) {
				event.preventDefault();
				document.querySelector("#close-sidebar").click();
			}
        }
    });

	document.addEventListener("mousedown", function () {
		if (document.body.classList.contains("focuson")) {
			document.body.classList.remove("focuson");
		}
	});

    const memberMenuLinks = document.querySelectorAll("#member-menu-box a");

    // Add tabindex to make links focusable
    memberMenuLinks.forEach(link => {
        link.setAttribute("tabindex", "0");
    });

    // Handle keyboard navigation for the member menu
    document.addEventListener("keydown", function (event) {
        const focusedElement = document.activeElement;

		const memberMenuEl = document.querySelector("#member-menu");
		if (memberMenuEl && memberMenuEl.classList.contains("is-active")) {
			const linksArray = Array.from(memberMenuLinks);
			const currentIndex = linksArray.indexOf(focusedElement);

			if (event.key === "ArrowDown") {
				// Move to the next menu item
				event.preventDefault();
				const nextIndex = (currentIndex + 1) % linksArray.length;
				linksArray[nextIndex].focus();
			} else if (event.key === "ArrowUp") {
				// Move to the previous menu item
				event.preventDefault();
				const prevIndex = (currentIndex - 1 + linksArray.length) % linksArray.length;
				linksArray[prevIndex].focus();
			}
		}

        // Handle Esc key to close the member menu
		const memberMenu = document.querySelector("#member-menu");
		if (
			event.key === "Escape" &&
			memberMenu &&
			memberMenu.classList.contains("is-active")
		) {
			event.preventDefault();
			memberMenu.classList.remove("is-active");
		}
    });

    const waysToLearnLinks = document.querySelectorAll(".ways-to-learn-menu a");

    // Add tabindex to make links focusable
    waysToLearnLinks.forEach(link => {
        link.setAttribute("tabindex", "0");
    });

    // Handle keyboard navigation for the ways-to-learn menu
    document.addEventListener("keydown", function (event) {
        const focusedElement = document.activeElement;

		const waysToLearnMenu = document.querySelector(".ways-to-learn-menu");
		if (waysToLearnMenu && waysToLearnMenu.classList.contains("is-active")) {
			const linksArray = Array.from(waysToLearnLinks);
			const currentIndex = linksArray.indexOf(focusedElement);

			if (event.key === "ArrowDown") {
				// Move to the next menu item
				event.preventDefault();
				const nextIndex = (currentIndex + 1) % linksArray.length;
				linksArray[nextIndex].focus();
			} else if (event.key === "ArrowUp") {
				// Move to the previous menu item
				event.preventDefault();
				const prevIndex = (currentIndex - 1 + linksArray.length) % linksArray.length;
				linksArray[prevIndex].focus();
			}

			// Handle Esc key to close the ways-to-learn menu
			if (event.key === "Escape") {
				event.preventDefault();
				document.querySelector("#close-ways").click();
			}
		}
    });
	
});